/*
 * MCS — Coordination des widgets flottants (coin inférieur droit).
 * Un seul panneau ouvert à la fois :
 *   - Ouvrir l'assistance (Shopify Inbox <shopify-chat open>) ferme Smile (SmileUI.closePanel()).
 *   - Ouvrir le panneau Smile (#smile-ui-container .smile-panel-frame-container) ferme l'assistance.
 * Tout est défensif (try/catch, optional-chaining manuel) : si un widget change sa
 * structure, le script échoue silencieusement sans rien casser.
 */
(function () {
  'use strict';

  function closeSmile() {
    try {
      if (window.SmileUI && typeof window.SmileUI.closePanel === 'function') {
        window.SmileUI.closePanel();
      }
    } catch (e) {}
  }

  function closeInbox() {
    try {
      var chat = document.querySelector('shopify-chat');
      if (!chat || !chat.hasAttribute('open')) return;
      var runtime = chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
      var rt = runtime && runtime.shadowRoot;
      var closeHost = rt && (rt.querySelector('.panel__close') || rt.querySelector('shopify-chat-icon-button[name="close"]'));
      var btn = closeHost && closeHost.shadowRoot && closeHost.shadowRoot.querySelector('button');
      if (btn) { btn.click(); return; }
      chat.removeAttribute('open'); // filet de sécurité si le bouton est introuvable
    } catch (e) {}
  }

  function smilePanelOpen() {
    var c = document.getElementById('smile-ui-container');
    if (!c) return false;
    var panel = c.querySelector('.smile-panel-frame-container');
    if (!panel || panel.offsetParent === null) return false;
    var r = panel.getBoundingClientRect();
    return r.height > 10 && r.width > 10;
  }

  var inboxWired = false, smileWired = false;

  function wireInbox() {
    if (inboxWired) return;
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;
    inboxWired = true;
    var obs = new MutationObserver(function () {
      if (chat.hasAttribute('open')) closeSmile();
    });
    obs.observe(chat, { attributes: true, attributeFilter: ['open'] });
    if (chat.hasAttribute('open')) closeSmile();
  }

  function wireSmile() {
    if (smileWired) return;
    var c = document.getElementById('smile-ui-container');
    if (!c) return;
    smileWired = true;
    var wasOpen = smilePanelOpen();
    var obs = new MutationObserver(function () {
      var open = smilePanelOpen();
      if (open && !wasOpen) closeInbox();
      wasOpen = open;
    });
    obs.observe(c, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  function tryWire() {
    wireInbox();
    wireSmile();
    return inboxWired && smileWired;
  }

  // Les deux widgets sont injectés de façon asynchrone → on réessaie jusqu'à ce qu'ils existent.
  if (!tryWire()) {
    var bodyObs = new MutationObserver(function () {
      if (tryWire()) { try { bodyObs.disconnect(); } catch (e) {} }
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { bodyObs.disconnect(); } catch (e) {} }, 30000);
  }
})();
